module.exports = __webpack_public_path__ + "img/pic_title_img3.db692256.png";